export default "__VITE_ASSET__CfuZy9e$__"